export default __webpack_public_path__ + "assets/images/95b6a27a26ace7426aa0a8e79a699f60.png";